/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Open360NfcStickersModelsNfcOperation {
    ID?: string;
    /**
     * 1 = Enqueued, 2 = Processing, 3 = Assigned, 4 = NotEnoughStickers
     */
    State?: Open360NfcStickersModelsNfcOperation.StateEnum;
    PlacesCount?: number;
    ItemsCount?: number;
    AssignedCount?: number;
    Date?: Date;
    /**
     * 1 = Assignment, 2 = AssignmentWithReplace, 3 = Export
     */
    Kind?: Open360NfcStickersModelsNfcOperation.KindEnum;
    Total?: number;
}
export namespace Open360NfcStickersModelsNfcOperation {
    export type StateEnum = 1 | 2 | 3 | 4;
    export const StateEnum = {
        NUMBER_1: 1 as StateEnum,
        NUMBER_2: 2 as StateEnum,
        NUMBER_3: 3 as StateEnum,
        NUMBER_4: 4 as StateEnum
    }
    export type KindEnum = 1 | 2 | 3;
    export const KindEnum = {
        NUMBER_1: 1 as KindEnum,
        NUMBER_2: 2 as KindEnum,
        NUMBER_3: 3 as KindEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360NfcStickersModelsNfcOperation.ts